// CACTUS KNIGHT - Cookie-Consent-Banner
// Speichert die Entscheidung (akzeptiert/abgelehnt) ueber die robuste
// Storage-Hilfsfunktion aus storage-helpers.js (mit In-Memory-Fallback).
//
// FUNKTIONALE SPERRE: Nicht-essenzielle Skripte werden nicht als normales
// <script> eingebunden, sondern als:
//   <script type="text/plain" data-cookie-consent="required" src="...">
// Mit type="text/plain" laedt/fuehrt der Browser das Skript gar nicht erst
// aus. Erst nach "Alle akzeptieren" (oder wenn diese Entscheidung schon
// vorher gespeichert wurde) wandelt ckActivateConsentedScripts() diese
// Platzhalter in echte, ausfuehrende <script>-Tags um.
//
// SHOPIFY-CUSTOMER-PRIVACY-API-ABGLEICH: Jede Entscheidung wird zusaetzlich
// an Shopifys eigene Consent-API gemeldet (window.Shopify.customerPrivacy),
// damit Shopify selbst dieselbe Entscheidung kennt. Beim ersten Laden wird
// zusaetzlich geprueft, ob Shopify bereits eine Entscheidung kennt.

const CK_COOKIE_CONSENT_KEY = "ck_cookie_consent";

function ckGetCookieConsent() {
  return ckStorageGet(CK_COOKIE_CONSENT_KEY);
}

function ckSetCookieConsent(value) {
  ckStorageSet(CK_COOKIE_CONSENT_KEY, value);
  document.dispatchEvent(new CustomEvent("ck-cookie-consent-updated", { detail: value }));
}

function ckActivateConsentedScripts() {
  document
    .querySelectorAll('script[type="text/plain"][data-cookie-consent="required"]')
    .forEach((placeholder) => {
      const real = document.createElement("script");
      Array.from(placeholder.attributes).forEach((attr) => {
        if (attr.name === "type" || attr.name === "data-cookie-consent") return;
        real.setAttribute(attr.name, attr.value);
      });
      real.textContent = placeholder.textContent;
      placeholder.replaceWith(real);
    });
}

function ckWithShopifyPrivacyApi(callback) {
  if (!(window.Shopify && typeof window.Shopify.loadFeatures === "function")) return false;
  window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (error) => {
    if (error || !window.Shopify.customerPrivacy) return;
    callback(window.Shopify.customerPrivacy);
  });
  return true;
}

function ckSyncShopifyConsent(accepted) {
  ckWithShopifyPrivacyApi((api) => {
    api.setTrackingConsent(
      {
        analytics: accepted,
        marketing: accepted,
        preferences: accepted,
        sale_of_data: accepted,
      },
      () => {}
    );
  });
}

function ckReadShopifyConsent(callback) {
  const started = ckWithShopifyPrivacyApi((api) => {
    try {
      const c = api.currentVisitorConsent();
      if (c && c.marketing === "yes") return callback("accepted");
      if (c && c.marketing === "no") return callback("declined");
      callback(null);
    } catch (e) {
      callback(null);
    }
  });
  if (!started) callback(null);
}

document.addEventListener("DOMContentLoaded", () => {
  const banner = document.getElementById("cookie-banner");
  const acceptBtn = document.getElementById("cookie-accept");
  const declineBtn = document.getElementById("cookie-decline");

  function applyConsent(consent) {
    if (consent === "accepted") {
      ckActivateConsentedScripts();
    }
    if (consent) {
      ckSyncShopifyConsent(consent === "accepted");
    }
    if (banner && !consent) {
      banner.removeAttribute("hidden");
    }
  }

  const localConsent = ckGetCookieConsent();
  if (localConsent) {
    applyConsent(localConsent);
  } else {
    ckReadShopifyConsent((shopifyConsent) => {
      if (shopifyConsent) {
        ckSetCookieConsent(shopifyConsent);
      }
      applyConsent(shopifyConsent);
    });
  }

  acceptBtn &&
    acceptBtn.addEventListener("click", () => {
      ckSetCookieConsent("accepted");
      ckSyncShopifyConsent(true);
      ckActivateConsentedScripts();
      if (banner) banner.setAttribute("hidden", "");
    });

  declineBtn &&
    declineBtn.addEventListener("click", () => {
      ckSetCookieConsent("declined");
      ckSyncShopifyConsent(false);
      if (banner) banner.setAttribute("hidden", "");
    });
});
